import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const create = async (data: { name: string }) => {
  return httpRequest.post("/erp/back_office/item_reference/manufacturer", data);
};

export const select = async (data: { query: string; limit?: number }) => {
  return httpRequest.get("/erp/back_office/item_reference/manufacturer/select", data);
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/erp/back_office/item_reference/manufacturer", { offset, filter });
};

export const update = async (id: string, data: { name: string }) => {
  return httpRequest.put(`/erp/back_office/item_reference/manufacturer/${id}`, data);
};

export const remove = async (id: string) => {
  return httpRequest.del(`/erp/back_office/item_reference/manufacturer/${id}`);
};
